export default {
  data () {
    return {
      iframe: null
    }
  },

  methods: {
    buildIframe () {
      if (this.iframe) {
        return
      }

      this.iframe = document.createElement('iframe')
      this.iframe.addEventListener('load', () => {
        this.onIframeLoaded()
      })

      this.$el.querySelector('.iframe-container').appendChild(this.iframe)
    },

    destroyIframe () {
      if (!this.iframe) {
        return
      }

      this.iframe.removeEventListener('load', this.onIframeLoaded)
      this.iframe.parentElement.removeChild(this.iframe)
      this.iframe = null
    },

    browseTo (url) {
      if (!this.iframe) {
        this.buildIframe()
      }

      this.iframe.src = url
      this.$emit('iframe-loading')
    },

    onIframeLoaded () {
      this.$emit('iframe-loaded')
    }
  },

  beforeDestroy () {
    this.destroyIframe()
  }
}
